import { render, staticRenderFns } from "./SaltoLocksTable.vue?vue&type=template&id=e2a4ad74&"
import script from "./SaltoLocksTable.vue?vue&type=script&lang=ts&"
export * from "./SaltoLocksTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports